import { render, staticRenderFns } from "./PatientLookup.vue?vue&type=template&id=06cfd880"
import script from "./PatientLookup.vue?vue&type=script&lang=js"
export * from "./PatientLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports